import React from "react";
import main from "../../images/LandingPageImage/business_for_all.webp";
import printer from "../../images/LandingPageImage/pos_solution.webp";
import box from "../../images/LandingPageImage/smart_inventory.webp";
import bike from "../../images/LandingPageImage/delivery_solution.webp";
import { Check } from "lucide-react";

const BuiltForBusiness = () => {
  return (
    <>
      <style>{`

.business-wrapper {
  position: relative;
  padding: 80px 0;
  background: #f9fdfb;
  overflow: hidden;
}

.business-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
background-image: url(${main});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;  
  z-index: 0;
}

.business-wrapper > .container {
  position: relative;
  z-index: 1;
}

.tick-circle {
  width: 22px;
  height: 22px;
  background-color: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tick-circle svg {
  color: #fff;
}

.card-section {
max-width: 800px;
margin: 0 auto;
}

.feature-card {
  border: 2px solid #3cb371;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  background: #fff;
  text-align: center;
}

.built-desc {
max-width: 450px;
text-align: center;
 margin: 0 auto;
}

.feature-img {
  width: 80px;
  height: auto;
}

.feature-card ul {
  list-style: none;
  padding: 0;
  margin-top: 15px;
}

.feature-card ul li {
  font-size: 14px;
  margin-bottom: 6px;
  color: #555;
}

.comparison-box {
  border: 2px solid #3cb371;
  border-radius: 16px;
  padding: 20px;
  max-width: 700px;
  background: #fff;
}

.vs-circle {
  width: 60px;
  height: 60px;
  background: #3cb371;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin: auto;
}

.bottom-feature {
max-width: 700px;
margin: 0 auto;
}

@media (max-width: 767px) {
  .business-wrapper {
    padding: 40px 0;
  }

  .business-wrapper::before {
    background-size: 135% auto;  
    background-position: top center;
    transform: scale(1.1);        
    transform-origin: top center;
  }
    .built-desc {
max-width: 300px;
text-align: center;
 margin: 0 auto;
}
}

    `}</style>

      <section
        className="business-wrapper"
      >
        <div className="container text-center">
          <h2 className="fw-bold text-success mb-2">
            Designed for Restaurants to Increase Profits
          </h2>
          <p className="text-muted mb-5 built-desc">
           From promotions to customer follow-ups, Anlook simplifies restaurant marketing. Engage diners better, reduce manual effort and grow sales effortlessly.
          </p>

          {/* Cards */}
          <div className="row g-4 justify-content-center card-section">
           
            <div className="col-md-4">
              <div className="feature-card h-100">
                <img src={printer} alt="POS" className="feature-img" />
                <h5 className="mt-3">Free POS Billing Software</h5>
                <ul>
                  <li>Quick billing process</li>
                  <li>Easy staff usage</li>
                  <li>Live sales reports</li>
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card h-100">
                <img src={box} alt="Inventory" className="feature-img" />
                <h5 className="mt-3">Smart Inventory Management</h5>
                <ul>
                  <li>Auto stock updates</li>
                  <li>Low-stock alerts</li>
                  <li>Waste reduction</li>
                </ul>
              </div>
            </div>

            <div className="col-md-4">
              <div className="feature-card h-100">
                <img src={bike} alt="Delivery" className="feature-img" />
                <h5 className="mt-3">Delivery Management Solution</h5>
                <ul>
                  <li>Centralized delivery control</li>
                  <li>Live order tracking</li>
                  <li>Faster deliveries</li>
                </ul>
              </div>
            </div>
          </div>

          <h4 className="fw-bold mt-5 mb-3 text-success">
           Lower Costs, Higher Profits.
          </h4>

          <div className="comparison-box mx-auto">
            <div className="row align-items-center">
              <div className="col-md-5">
                <h6 className="fw-bold">Our Solution</h6>
                <p>
                  Lower Commission <br /> Rate, Fair Pricing
                </p>
              </div>

              <div className="col-md-2">
                <div className="vs-circle">VS</div>
              </div>

              <div className="col-md-5">
                <h6 className="fw-bold">Other Platform</h6>
                <p>
                  25–30% <br /> Commission Rate
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Features */}
          <div className="row mt-4 bottom-feature">
            <div className="col-md-4 d-flex align-items-center justify-content-center">
              <div className="d-flex align-items-center gap-2 fw-semibold text-success">
                <span className="tick-circle">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span>No High Commissions</span>
              </div>
            </div>

            <div className="col-md-4 d-flex align-items-center justify-content-center">
              <div className="d-flex align-items-center gap-2 fw-semibold text-success">
                <span className="tick-circle">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span>One Simple Platform</span>
              </div>
            </div>
            <div className="col-md-4 d-flex align-items-center justify-content-center">
              <div className="d-flex align-items-center gap-2 fw-semibold text-success">
                <span className="tick-circle">
                  <Check size={14} strokeWidth={3} />
                </span>
                <span>More Control & Profits</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BuiltForBusiness;
